import { Typography } from '@weareopenr/component-library';
import { ReactElement } from 'react';
import { formatPrice } from 'src/helpers/formatPrice/formatPrice';
import styles from './Modifier.module.scss';
import { Link } from 'react-router-dom';

export type ModifierProps = {
  posId: string;
  name: string;
  price: number;
  link: string;
  inheritPrice: boolean;
  min?: number | null;
  max?: number | null;
  default?: number | null;
};
const getPrice = (price: number | null, shouldInheritFromParent: boolean) => {
  if (shouldInheritFromParent) {
    return 'Inherited';
  }
  return price !== null ? formatPrice(price) : '-';
};

const getPosId = (posId: string) => {
  if (!posId) {
    return 'Inherited';
  }
  return posId;
};

const Modifier = ({
  posId,
  name,
  price,
  link,
  inheritPrice,
  min,
  max,
  default: defaultVal,
}: ModifierProps): ReactElement => {
  const fields = [
    { label: 'Price', value: getPrice(price, inheritPrice) },
    { label: 'POS ID', value: getPosId(posId) },
    { label: 'Default', value: defaultVal ?? '-' },
    { label: 'Min', value: min ?? '-' },
    { label: 'Max', value: max ?? '-' },
  ];

  return (
    <div className={styles['modifier-container']}>
      <Link title={name} className={styles['modifier-link']} to={link}>
        {name}
      </Link>
      <div className={styles['inner-container']}>
        {fields.map(({ label, value }) => (
          <div key={label} className={styles['item']}>
            <Typography weight="bold" size="xsmall" className={styles['item-title']}>
              {label}
            </Typography>
            <Typography size="xsmall">{value}</Typography>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Modifier;
